(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-build-a-set"] && !Shopify.designMode) return;
  try {
    
  class BuildASet extends HTMLElement {
    constructor() {
      super();
      this.columns = Array.from(this.querySelectorAll('[data-bas-column]'));
      this.submitButton = this.querySelector('[data-bas-submit]');
      this.statusEl = this.querySelector('[data-bas-status]');
      this.currency = this.dataset.currency || 'USD';
      this.selections = {};
      this.cycleEnabled = this.dataset.cycleEnabled === 'true';
      this.cycleSpeed = parseFloat(this.dataset.cycleSpeed || '2') * 1000;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.columns.forEach((column) => {
        const select = column.querySelector('[data-bas-product-select]');
        select.addEventListener('change', () => this.onProductChange(column, select));
        this.startCycling(column, select);
      });

      if (this.submitButton) {
        this.submitButton.addEventListener('click', () => this.onSubmit());
      }
    }

    startCycling(column, select) {
      if (!this.cycleEnabled || this.prefersReducedMotion) return;
      this.stopCycling(column);

      const images = Array.from(select.options)
        .filter((option) => option.value && option.dataset.image)
        .map((option) => option.dataset.image);

      if (images.length < 2) return;

      const imageEl = column.querySelector('.bas-image');
      if (!imageEl) return;

      let cycleIndex = 0;
      column._cycleInterval = setInterval(() => {
        cycleIndex = (cycleIndex + 1) % images.length;
        this.swapImage(imageEl, images[cycleIndex]);
      }, this.cycleSpeed);
    }

    stopCycling(column) {
      if (column._cycleInterval) {
        clearInterval(column._cycleInterval);
        column._cycleInterval = null;
      }
    }

    swapImage(imageEl, newSrc) {
      if (!imageEl || !newSrc || imageEl.src === newSrc) return;

      const fadeMs = 300;

      // Start loading the new image immediately, in parallel with the fade-out,
      // so it's very likely ready by the time the fade-out finishes.
      const preload = new Image();
      preload.src = newSrc;

      imageEl.style.opacity = '0';

      clearTimeout(imageEl._swapTimeout);
      imageEl._swapTimeout = setTimeout(() => {
        imageEl.removeAttribute('srcset');
        imageEl.removeAttribute('sizes');
        imageEl.src = newSrc;
        requestAnimationFrame(() => {
          imageEl.style.opacity = '1';
        });
      }, fadeMs);
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.currency,
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    onProductChange(column, select) {
      const index = column.dataset.columnIndex;
      const optionsWrapper = column.querySelector('[data-bas-variant-options]');
      const priceEl = column.querySelector('[data-bas-price]');
      const imageEl = column.querySelector('.bas-image');
      const errorEl = column.querySelector('[data-bas-column-error]');

      optionsWrapper.innerHTML = '';
      priceEl.textContent = '';
      errorEl.style.display = 'none';
      delete this.selections[index];

      const selectedOption = select.selectedOptions[0];
      if (!selectedOption || !selectedOption.value) {
        this.startCycling(column, select);
        this.updateSubmitState();
        return;
      }

      this.stopCycling(column);

      let productOptions = [];
      let variants = [];
      try {
        productOptions = JSON.parse(selectedOption.dataset.options || '[]');
        variants = JSON.parse(selectedOption.dataset.variants || '[]');
      } catch (e) {
        variants = [];
      }

      if (selectedOption.dataset.image) {
        this.swapImage(imageEl, selectedOption.dataset.image);
      }

      column._productOptions = productOptions;
      column._variants = variants;
      column._chosenValues = new Array(productOptions.length).fill(null);

      if (productOptions.length === 1 && productOptions[0].values.length === 1) {
        // Single option, single value: nothing for the customer to choose.
      } else {
        productOptions.forEach((option, optionIndex) => {
          const wrapper = document.createElement('div');
          const label = document.createElement('label');
          label.textContent = option.name;
          label.style.display = 'block';
          label.style.fontSize = '1.2rem';
          label.style.marginBottom = '0.2rem';

          const optionSelect = document.createElement('select');
          optionSelect.className = 'bas-select';
          optionSelect.dataset.optionIndex = optionIndex;

          const placeholderOpt = document.createElement('option');
          placeholderOpt.value = '';
          placeholderOpt.textContent = 'Choose ' + option.name;
          optionSelect.appendChild(placeholderOpt);

          option.values.forEach((value) => {
            const opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            optionSelect.appendChild(opt);
          });

          optionSelect.addEventListener('change', () => {
            column._chosenValues[optionIndex] = optionSelect.value || null;
            this.updateVariantMatch(column, priceEl, imageEl, errorEl);
          });

          wrapper.appendChild(label);
          wrapper.appendChild(optionSelect);
          optionsWrapper.appendChild(wrapper);
        });
      }

      this.updateVariantMatch(column, priceEl, imageEl, errorEl);
    }

    updateVariantMatch(column, priceEl, imageEl, errorEl) {
      const index = column.dataset.columnIndex;
      const variants = column._variants || [];
      const productOptions = column._productOptions || [];
      const chosen = column._chosenValues || [];

      const needsAllChosen = productOptions.length > 1 || (productOptions[0] && productOptions[0].values.length > 1);
      if (needsAllChosen && chosen.some((v) => !v)) {
        delete this.selections[index];
        this.updateSubmitState();
        return;
      }

      const match = variants.find((variant) => {
        return variant.options.every((optValue, i) => {
          if (!needsAllChosen) return true;
          return optValue === chosen[i];
        });
      }) || variants[0];

      if (!match) {
        errorEl.textContent = 'This combination is unavailable.';
        errorEl.style.display = 'block';
        delete this.selections[index];
        this.updateSubmitState();
        return;
      }

      if (!match.available) {
        errorEl.textContent = 'That combination is sold out.';
        errorEl.style.display = 'block';
        delete this.selections[index];
        this.updateSubmitState();
        return;
      }

      errorEl.style.display = 'none';
      priceEl.textContent = this.formatMoney(match.price);
      if (match.image) {
        this.swapImage(imageEl, match.image);
      }
      this.selections[index] = match.id;
      this.updateSubmitState();
    }

    updateSubmitState() {
      // Intentionally not disabling the button outright, so the customer
      // always gets a clear message about what's missing when they click.
    }

    async onSubmit() {
      const totalColumns = this.columns.length;
      const chosenCount = Object.keys(this.selections).length;

      if (chosenCount < totalColumns) {
        this.showStatus('Please choose an option for every column.', 'error');
        return;
      }

      const items = Object.values(this.selections).map((id) => ({ id, quantity: 1 }));
      const buttonText = this.submitButton.querySelector('[data-bas-button-text]');
      const originalText = buttonText.textContent;
      this.submitButton.disabled = true;
      buttonText.textContent = 'Adding...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Could not add items to cart');
        }

        this.showStatus(this.dataset.successMessage || 'Added to your cart! Redirecting...', 'success');
        window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart'
          : '/cart';
        return;
      } catch (err) {
        this.showStatus(this.dataset.errorMessage || "Something went wrong, please try again.", 'error');
      } finally {
        this.submitButton.disabled = false;
        buttonText.textContent = originalText;
      }
    }

    showStatus(message, type) {
      if (!this.statusEl) return;
      this.statusEl.textContent = message;
      this.statusEl.className = 'bas-status bas-status--' + type;
    }
  }

  if (!customElements.get('build-a-set')) {
    customElements.define('build-a-set', BuildASet);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-form-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getDialog(id) {
      return document.getElementById('FormPopup-' + id);
    }
    function openDialog(dlg) {
      if (!dlg || dlg.open) return;
      dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDialog(dlg) {
      if (dlg && dlg.open) dlg.close();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-form-popup-open]');
      if (opener) {
        openDialog(getDialog(opener.getAttribute('data-form-popup-open')));
        return;
      }
      var closer = e.target.closest('[data-form-popup-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }
      // Click on the backdrop (the dialog element itself) closes it
      if (e.target.classList && e.target.classList.contains('form-popup__dialog')) {
        closeDialog(e.target);
        return;
      }
      // Any link pointing at the trigger hash opens the matching popup
      var link = e.target.closest('a[href^="#"]');
      if (link) {
        var hash = link.getAttribute('href').slice(1);
        var match = document.querySelector('dialog.form-popup__dialog[data-hash="' + hash + '"]');
        if (match) {
          e.preventDefault();
          openDialog(match);
        }
      }
    });

    document.addEventListener(
      'close',
      function (e) {
        if (e.target.classList && e.target.classList.contains('form-popup__dialog')) {
          document.documentElement.style.overflow = '';
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header-menu"] && !Shopify.designMode) return;
  try {
    
  class StickyMenuBar extends HTMLElement {
    constructor() {
      super();
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
    }

    connectedCallback() {
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 0;
      const dockPoint = headerHeight + this.offsetHeight;

      if (scrollTop <= dockPoint) {
        // Still above (or at) our natural resting position: stay visible, no animation.
        this.classList.remove('sticky-menu-bar--hidden');
      } else if (scrollTop > this.currentScrollTop) {
        // Scrolling down past that point: hide.
        this.classList.add('sticky-menu-bar--hidden');
      } else if (scrollTop < this.currentScrollTop) {
        // Scrolling up: reveal.
        this.classList.remove('sticky-menu-bar--hidden');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  if (!customElements.get('sticky-menu-bar')) {
    customElements.define('sticky-menu-bar', StickyMenuBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
